import { FullScreenLoading } from "components/ui/Loading/Loading";
import { hasLicense, LICENSE_KEY } from "constants/licenses";
import { AuthContext } from "hooks/authProvider/authProvider";
import { useCrmPermission } from "hooks/useCrmPermission";
import type React from "react";
import { useContext, useMemo } from "react";
import CrmDashboard from "routes/HomePage/components/CrmDashboard";
import { HomePage } from "routes/HomePage/HomePage";
import { getCurrentTenant } from "utils/authority-utils";

const HomePageContainer: React.VFC = () => {
  const { currentUser, isLoadingUser, authError } = useContext(AuthContext);
  const { hasCrmAccess } = useCrmPermission();

  const licenses = useMemo(() => {
    const tenant = getCurrentTenant(currentUser);
    return tenant?.licenses;
  }, [currentUser]);

  const hasEmailSearch = useMemo(
    () => hasLicense(licenses, LICENSE_KEY.EMAIL_SEARCH),
    [licenses],
  );
  const hasBulkDelivery = useMemo(
    () => hasLicense(licenses, LICENSE_KEY.BULK_DELIVERY),
    [licenses],
  );

  if (authError) {
    return <div>{JSON.stringify(authError, null, 2)}</div>;
  }
  if (isLoadingUser || !currentUser) {
    return <FullScreenLoading />;
  }

  if (hasCrmAccess) {
    return <CrmDashboard />;
  }

  return (
    <HomePage
      hasEmailSearch={hasEmailSearch}
      hasBulkDelivery={hasBulkDelivery}
    />
  );
};

export default HomePageContainer;
